import { Locale } from "date-fns";
import { enGB } from "date-fns/locale";
import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";

const localeLoaders = import.meta.glob(
  "/node_modules/date-fns/esm/locale/*/index.js"
);

const toDateFnsDir = (code: string): string => {
  if (code.toLowerCase() === ENGLISH_LANG_CODE) return "en-GB";

  const [lang, region] = code.split("-");

  return region
    ? `${lang.toLowerCase()}-${region.toUpperCase()}`
    : lang.toLowerCase();
};

const loadDateFnsLocale = async (code: string): Promise<Locale> => {
  const suffix = `/locale/${toDateFnsDir(code)}/index.js`;
  const entry = Object.entries(localeLoaders).find(([path]) =>
    path.endsWith(suffix)
  );

  if (!entry) return enGB;

  try {
    const mod = (await entry[1]()) as { default?: Locale };

    return mod.default ?? enGB;
  } catch {
    return enGB;
  }
};

export default loadDateFnsLocale;
